/* Pure placement math for the SearchableSelect portal menu. No DOM. */

export interface MenuPlacementInput {
  triggerRect: { top: number; bottom: number; left: number; width: number };
  viewport: { width: number; height: number };
  /** Natural (uncapped) height of the menu content. */
  contentHeight: number;
  /** Natural width the longest row wants (before the cap). */
  contentWidth: number;
  /** Space kept between the menu and the viewport edge / trigger. */
  gutter: number;
  /** Sane upper bound for the menu width. */
  maxWidth?: number;
}

export interface MenuPlacement {
  top: number;
  left: number;
  width: number;
  maxHeight: number;
  direction: 'below' | 'above';
}

export function computeMenuPlacement(i: MenuPlacementInput): MenuPlacement {
  const { triggerRect: t, viewport: v, contentHeight, contentWidth, gutter } = i;
  const maxWidth = i.maxWidth ?? 480;

  const spaceBelow = Math.max(0, v.height - t.bottom - gutter * 2);
  const spaceAbove = Math.max(0, t.top - gutter * 2);
  const fitsBelow = contentHeight <= spaceBelow;
  const direction: 'below' | 'above' = fitsBelow || spaceBelow >= spaceAbove ? 'below' : 'above';
  const space = direction === 'below' ? spaceBelow : spaceAbove;
  const height = Math.min(contentHeight, space);

  const width = Math.min(
    Math.max(t.width, Math.min(contentWidth, maxWidth)),
    Math.max(0, v.width - gutter * 2)
  );
  const left = Math.max(gutter, Math.min(t.left, v.width - width - gutter));
  const top = direction === 'below' ? t.bottom + gutter : t.top - gutter - height;

  return { top, left, width, maxHeight: space, direction };
}
